import { fetch } from '../../utils';
import Backend, { DataBackend } from '../../backend';
import { getDataAnalyticsAccessToken } from '../auth/api';


export const autoEnrollApi = async () => {
  const token = await getDataAnalyticsAccessToken();

  const header = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  };

  const rewardSummary = async () => {
    const _endpoint = '/missions-and-rewards/user-reward-summary';
    return await (
      await fetch(DataBackend.methodUrl(_endpoint), {
        headers: header,
        method: 'GET'
      })
    ).json();
  };

  const enrollments = async () => {
    const _endpoint = '/missions-and-rewards/auto-enroll';
    return await (
      await fetch(DataBackend.methodUrl(_endpoint), {
        headers: header,
        method: 'POST'
      })
    ).json();
  };

  const [enrollmentsResponse, rewardSummaryResponse] = await Promise.all([enrollments(), rewardSummary()]);
  return {
    enrollments: enrollmentsResponse.data,
    rewardSummary: rewardSummaryResponse.data
  };
};

export const getRewardSummaryApi = async () => {
  const token = await getDataAnalyticsAccessToken();
  const endpoint = '/missions-and-rewards/reward-summary';
  const response = await fetch(DataBackend.methodUrl(endpoint), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

/**
 * @param {string} enrollmentId
 * @param {string} mission
 * @param {string} requirement
 * @param {string | number} value
 * @optional @param {boolean} checkCompleted
 */
export const trackMissionProgressApi = async ({ sources, value, action }) => {
  // track/:enrollmentId
  // const enrollmentId = req.params.enrollmentId;
  // const { mission, requirement, value, checkCompleted = false } = req.body;
  // checkCompleted is optional and default to false

  // if (!sources || !value || !action || !sources.length) {
  //   console.log("sources, value, action, and sources length are required", sources, value, action, sources.length);
  // }

  //   {
  //     "source": "693a9b0342dbe5a2dc1d7a9c.693a9ac042dbe5a2dc1d7a58.693a9ac042dbe5a2dc1d7a5d.693a9ac042dbe5a2dc1d7a5e",
  //     "value": 1,
  //     "action": "shareHotTopic"
  //  }
  const token = await getDataAnalyticsAccessToken();
  const endpoint = `/missions-and-rewards/track/sources`;

  const _s = Array.from(sources).map(source => ({
    source,
    value,
    action: action
  }));
  const body = {
    sources: _s
  };
  // console.log('trackMissionProgressApi body::: ', body);
  const response = await (
    await fetch(DataBackend.methodUrl(endpoint), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    })
  ).json();
  // console.log('trackMissionProgressApi response::: ', response);
  return response.data;
};



export const trackPublicEventApi = async (userId, eventId, contentId) => {
  // /user-public-trackable-event/:userI
  const endpoint = `/public/track/missions/${userId}/${eventId}`;
  const response = await fetch(DataBackend.methodUrl(endpoint), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      contentId: contentId
    })
  });
  return response.data;
};